var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInspectIqLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Logo",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 558.04 556.39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #005477;\n      }\n\n      .cls-2 {\n        fill: #015379;\n      }\n\n      .cls-3 {\n        fill: #01567a;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logo-2",
    "data-name": "Logo"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Upper"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 526.41,
    cy: 83.97,
    rx: 30.46,
    ry: 29.57
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 277.83,
    cy: 26.02,
    rx: 26.81,
    ry: 26.02
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 30.46,
    cy: 83.97,
    rx: 30.46,
    ry: 29.57
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M77.99,74.51h0v26.02h22.83c14.41,0,26.89,9.7,30.04,23.34l9.83,42.51h0c12.79-3.8,20.48-16.45,17.73-29.16l-4.88-22.5h0c-5.58-23.54-27.17-40.21-52.05-40.21h-23.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M204.72,89.89v58.1l13.31-6.02c11.21-5.07,18.38-15.99,18.38-28v-24.08h-31.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M261.99,121.04v-54.77h35.74v54.77c0,9.58-8,17.34-17.87,17.34h0c-9.87,0-17.87-7.77-17.87-17.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M359.47,89.89v58.1l-13.45-6.33c-10.41-4.9-17.02-15.14-17.02-26.37v-25.4h30.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M483.76,74.51h0v26.02h-22.83c-14.41,0-26.89,9.7-30.04,23.34l-9.83,42.51h0c-12.79-3.8-20.48-16.45-17.73-29.16l4.88-22.5h0c5.58-23.54,27.17-40.21,52.05-40.21h23.5Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Lower"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 31.63,
    cy: 472.41,
    rx: 30.46,
    ry: 29.57
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 280.21,
    cy: 530.37,
    rx: 26.81,
    ry: 26.02
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 527.58,
    cy: 472.41,
    rx: 30.46,
    ry: 29.57
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M480.05,481.88h0v-26.02h-22.83c-14.41,0-26.89-9.7-30.04-23.34l-9.83-42.51h0c-12.79,3.8-20.48,16.45-17.73,29.16l4.88,22.5h0c5.58,23.54,27.17,40.21,52.05,40.21h23.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M353.33,466.5v-58.1l-13.31,6.02c-11.21,5.07-18.38,15.99-18.38,28v24.08h31.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M296.06,435.35v54.77h-35.74v-54.77c0-9.58,8-17.34,17.87-17.34h0c9.87,0,17.87,7.77,17.87,17.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M198.57,466.5v-58.1l13.45,6.33c10.41,4.9,17.02,15.14,17.02,26.37v25.4h-30.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M74.28,481.88h0v-26.02h22.83c14.41,0,26.89-9.7,30.04-23.34l9.83-42.51h0c12.79,3.8,20.48,16.45,17.73,29.16l-4.88,22.5h0c-5.58,23.54-27.17,40.21-52.05,40.21h-23.5Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Main"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M142.7,279.92c0-48.39,26.66-90.74,66.5-113.96-31.17,7.98-59.52,19.84-84.3,32.92-13.59,24.19-21.32,51.93-21.32,81.43s7.22,55.36,19.97,78.96c30.26,16.86,59.54,28.44,87.65,35.76-40.94-22.96-68.49-65.91-68.49-115.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M80.42,279.13c0-20.91,3.44-41.03,9.78-59.88-46.63,30.24-73.94,59.88-73.94,59.88,25.09,23.63,49.73,43.3,73.83,59.55-6.27-18.76-9.67-38.77-9.67-59.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M413.09,277.94c0,48.39-26.66,90.74-66.5,113.96,31.17-7.98,59.52-19.84,84.3-32.92,13.59-24.19,21.32-51.93,21.32-81.43s-7.22-55.36-19.97-78.96c-30.26-16.86-59.54-28.44-87.65-35.76,40.94,22.96,68.49,65.91,68.49,115.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M475.36,278.74c0,20.91-3.44,41.03-9.78,59.88,46.63-30.24,73.94-59.88,73.94-59.88-25.09-23.63-49.73-43.3-73.83-59.55,6.27,18.76,9.67,38.77,9.67,59.55Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 230.3,
    y: 234.18,
    width: 95.05,
    height: 92.25
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M277.22,159.99c-66.85,0-121.04,52.6-121.04,117.49s54.19,117.49,121.04,117.49,121.04-52.6,121.04-117.49-54.19-117.49-121.04-117.49ZM366.7,307.69v15.61h-26.49v19.1h-15.95v20.57h-20.72v-20.87h-19.5v33.73h-18.15v-35.49h-16.53v19.21h-17.85l-.3-15.1-17.98-.43-.18-21.31-22.65.17.26-20.73h23l.13-15.79-37.11-.14v-13.01l38.8.16v-23.5l-26.4.3v-15.99h26.49v-18.72h15.95v-20.57h20.72v20.57l19.5-.21v-33.22h18.15v35.2h14.89v-18.92h19.5v15.53h18.28v21.14h22.83v20.11h-22.83v16.56h36.56v13.01h-38.89v23.04h26.49Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInspectIqLogo);
export default __webpack_public_path__ + "static/media/Inspect IQ Logo.88babeaf0bef7c1f7750121d2f39b160.svg";
export { ForwardRef as ReactComponent };